import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
    startZipCode: Yup.string()
        .required('CEP Início é obrigatório')
        .length(9, 'O CEP deve ter exatamente 9 caracteres'), // Validação de comprimento exato

    endZipCode: Yup.string()
        .required('CEP Fim é obrigatório')
        .length(9, 'O CEP deve ter exatamente 9 caracteres'),
});